import React, { useEffect } from "react";
import block from "bem-cn";
import { useSelector, useDispatch, shallowEqual } from "react-redux";

import SVG from "components/SVG";
import Modal from "components/Modal";

import useNotifications from "./model/useNotifications";
import useObserveNotifications from "./model/useObserveNotifications";

import NotificationsList from "./NotificationsList/NotificationsList";
import NotificationModal from "./NotificationModal/NotificationModal";

import { actions as notificationsActions } from "features/notifications/index";

import crossSVG from './img/cross.svg';
import './Notifications.scss';

const b = block('notifications');

const Notifications = () => {
  const dispatch = useDispatch();
  const locale = useSelector(state => state.locale.locale, shallowEqual);

  const model = useNotifications();

  const { containerRef, seenIds } = useObserveNotifications(model.notifications, model.notificationsVisible);
  useEffect(() => {
    if (!model.notificationsVisible && seenIds.length > 0) {
      dispatch(notificationsActions.setNotificationRead([...new Set(seenIds)]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [model.notificationsVisible]);

  return (
    <div className={b()}>
      {model.notificationsVisible && !model.activeItem && (
        <Modal onClose={model.handleToggleVisible}>
          <div className={b('container')} ref={containerRef}>
            <div className={b('header')}>
              <div className={b('counter')}>
                {locale.notification}: {model.notifications.length}
              </div>
              <div className={b('cross')}>
                <SVG
                  svgProps={{ svg: crossSVG }}
                  className={b('cross-icon').toString()}
                  onClick={model.handleToggleVisible}
                />
              </div>
            </div>
            <NotificationsList
              hideNotification={model.handleHideNotification}
              setActiveItem={model.setActiveItem}
              items={model.notifications}
            />
          </div>
        </Modal>
      )}

      {model.activeItem && (
        <NotificationModal onClose={model.setActiveItem} item={model.activeItem} />
      )}
    </div>
  );
};

export default Notifications;
